import React, { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
//import LoadingOverlay from 'react-loading-overlay'
import MetisMenu from 'react-metismenu'
import { useSelector } from 'react-redux'
import SchoolService from '../../services/school'
import { PERM, isAuthed } from '../../shared/utility'
import { HomeNav, PageNav, SocialMediaNav } from './NavItems'
import generateNavItems from './generateNavItems'

//LoadingOverlay.propTypes = undefined

const SidebarMenu = (props) => {

	const roles = useSelector((state) => state.auth.roles);
	const [isAdmin, setIsAdmin] = useState(false)
	const container = useRef(null)
	let [navData, setNavData] = useState(null);
	const schoolTypeId = props.schoolTypeId
	const loaderActive = true
	let isLoading = true

	const getSchoolTypeData = async (schoolTypeId) => {
		const res = await SchoolService.getSchoolTypeData(schoolTypeId)
		setNavData(generateNavItems(res.schoolTypes))
	};

	useEffect(() => {
		setIsAdmin(isAuthed(PERM.SHOW_ADMIN_SETTINGS))
		if (schoolTypeId) getSchoolTypeData(schoolTypeId)
	}, [roles, schoolTypeId]
	)

	const setIcons = (navData) => {
		for (let i = 0; i < navData.length; i++) {
			for (let ii = 0; ii < navData[i].data.length; ii++) {
				navData[i].data[ii].icon = "pe-7s-study"
			}
		}
	}

	let schoolMenu = null
	let basicMenu = null
	let adminMenu = null
	let socialMediaMenu = null

	if (navData) {
		isLoading = false
		setIcons(navData)
		schoolMenu = navData.map((el, index) => {
			return (
				<React.Fragment key={index}>
					<h5 className="app-sidebar__heading">{el.title}</h5>
					<MetisMenu
						content={el.data}
						onSelected={(el) => console.log(el)}
						activeLinkFromLocation
						className="vertical-nav-menu"
						iconNamePrefix=""
						classNameStateIcon="pe-7s-angle-down"
					/>
				</React.Fragment>
			)
		})

		adminMenu = (
			<React.Fragment key={998}>
				<h5 className="app-sidebar__heading">Admin</h5>
			</React.Fragment>
		)
	}

	if (window.innerWidth < 992) {
		if (!schoolTypeId) isLoading = false
		basicMenu = (
			<React.Fragment key={995}>
				<h5 className="app-sidebar__heading">Sidor</h5>
				<MetisMenu
					content={PageNav}
					activeLinkFromLocation
					className="vertical-nav-menu"
					iconNamePrefix=""
					classNameStateIcon="pe-7s-angle-down"
				/>
			</React.Fragment>
		)
		socialMediaMenu = (
			<React.Fragment key={996}>
				<h5 className="app-sidebar__heading">Sociala media</h5>
				<MetisMenu
					content={SocialMediaNav}
					activeLinkFromLocation
					className="vertical-nav-menu"
					iconNamePrefix=""
					classNameStateIcon="pe-7s-angle-down"
				/>
			</React.Fragment>
		)
		adminMenu = (
			<React.Fragment key={998}>
				<h5 className="app-sidebar__heading">Admin</h5>
			</React.Fragment>
		)
	}

	const homeMenu = (
		<React.Fragment key={997}>
			<MetisMenu
				content={HomeNav}
				activeLinkFromLocation
				className="vertical-nav-menu"
				iconNamePrefix=""
				classNameStateIcon="pe-7s-angle-down"
			/>
		</React.Fragment>
	);


	const loader = (
		<>
			{/*<LoadingOverlay
			tag="div"
			active={loaderActive}
			styles={{
				overlay: (base) => ({
					...base,
					background: '#fff',
					opacity: 0.5,
					marginTop: '300px'
				})
			}}
			spinner={<Loader color="#000000" active type={'ball-scale-ripple-multiple'} />}
		/>*/}
		</>
	);

	return <React.Fragment><div ref={container}>{isLoading ? loader : [homeMenu, schoolMenu, isAdmin ? adminMenu : null, basicMenu, socialMediaMenu]}</div></React.Fragment>
};

export default SidebarMenu
